import {
  Spacer,
  TitleCell,
  TitleRow
} from '../../../../components/ReusableComponents/Table'
import layoutStyles from '../PMSandBE.module.scss'

const PMSBEHealthTitleRow = ({ hideStopTestLogin = false, compactPepLayout = false }) => {
  if (compactPepLayout) {
    return (
      <TitleRow
        className={layoutStyles.pepCompactGridRowTitle}
        style={{ position: 'sticky', top: 70 }}
      >
        <TitleCell>Id</TitleCell>
        <TitleCell>Hotel name</TitleCell>
        <TitleCell>CSM</TitleCell>
        <TitleCell>Sync</TitleCell>
        <TitleCell>CSM action</TitleCell>
        <TitleCell>PEP status</TitleCell>
        <TitleCell>Details</TitleCell>
        <TitleCell>Notes</TitleCell>
      </TitleRow>
    )
  }

  if (hideStopTestLogin) {
    return (
      <TitleRow style={{ position: 'sticky', top: 70 }}>
        <TitleCell>Id</TitleCell>
        <TitleCell>Hotel name</TitleCell>
        <Spacer />
        <TitleCell>CSM</TitleCell>
        <TitleCell textAlign="center">PMS Sync</TitleCell>
        <TitleCell>Last SYNC</TitleCell>
        <TitleCell>
          Reports for <br /> last 48h
        </TitleCell>
        <TitleCell>PMS</TitleCell>
        <TitleCell>Last result</TitleCell>
        <TitleCell>Notes</TitleCell>
      </TitleRow>
    )
  }

  return (
    <TitleRow style={{ position: 'sticky', top: 70 }}>
      <TitleCell>Id</TitleCell>
      <TitleCell>Hotel name</TitleCell>
      <Spacer />
      <TitleCell>CSM</TitleCell>
      <TitleCell textAlign="center">PMS Sync</TitleCell>
      <TitleCell>Last SYNC</TitleCell>
      <TitleCell>
        Reports for <br /> last 48h
      </TitleCell>
      <TitleCell>PMS</TitleCell>
      <TitleCell>Last result</TitleCell>
      <TitleCell textAlign="center">Stop / Test login</TitleCell>
      <TitleCell>Notes</TitleCell>
    </TitleRow>
  )
}

export default PMSBEHealthTitleRow
